import script from "./CapNhatMinhChung.vue?vue&type=script&lang=ts&setup=true"
export * from "./CapNhatMinhChung.vue?vue&type=script&lang=ts&setup=true"

import "./CapNhatMinhChung.vue?vue&type=style&index=0&id=02f06026&lang=css"

const __exports__ = script;

export default __exports__